import { Simulado } from '../@types';
import {
  MocktestRegistrationsResponse,
  RegistrationCancelPayload,
  RegistrationEntry,
} from '../@types/Simulado';
import Service from './Service';

class InscritoService extends Service {
  static getInscritos() {
    return this.Http.get<Simulado.Inscrito[]>(
      '/registereds'
    ).then(this.getData);
  }

  static getLastFinished() {
    return this.Http.get<any[]>('/registereds/lastfinished').then(this.getData);
  }

  static getRankeds(mocktestID : string) {
    return this.Http.get<Simulado.Inscrito[]>(
      `/registereds/allranked/${mocktestID}`
    ).then(this.getData);
  }

  static getInscrito(id: string) {
    return this.Http.get<Simulado.Inscrito>(
      `/registereds/${id}`
    ).then(this.getData);
  }

  static deletePorSimuladoId(simuladoId: string) {
    return this.Http.delete<any>(
      `/registereds/${simuladoId}`
    ).then(this.getData);
  }

  static inserirNovoInscrito(inscrito: Simulado.Inscrito) {
    return this.Http.post<Simulado.Inscrito>(
      '/registereds',
      inscrito
    ).then(this.getData);
  }

  // finish user mocktest by registered
  static finishSimuladoUsuario() {
    return this.Http.put<Simulado.Inscrito>(
      '/registereds/finishusermocktest'
    ).then(this.getData);
  }

  static getMocktestRegistrations(mocktestId: string) {
    return this.Http.get<MocktestRegistrationsResponse>(`/mocktests/${mocktestId}/registrations`).then(this.getData);
  }

  static cancelRegistration(registrationId: string, payload: RegistrationCancelPayload) {
    return this.Http.post<RegistrationEntry>(`/registrations/${registrationId}/cancel`, payload).then(this.getData);
  }
}

export default InscritoService;
